export default {
  header: {
    recommend: 'We recommend you',
  },
  skip_checkout_button: {
    go_to_checkout: 'No, Proceed to Order',
  },
};
